import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';

@Injectable()
export class HttpService {

	// static get parameters() {
	// 	return [[HttpClient]];
	// }

	// serverAddr:string;

	constructor(
		private http: HttpClient,
		public loadingCtrl: LoadingController
	) {
	}

	get(url){
		return new Promise((resolve,reject)=>{
			console.log("url:"+url);
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;
			
			this.http.get(serverUrl).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}

	post(url, body){
		return new Promise((resolve,reject)=>{
			// let loader = this.loadingCtrl.create({
			// 	content: "loading..."
			// });
			// loader.present();
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(serverUrl, body, {headers:headers}).timeout(6000).subscribe((res:any)=>{
				resolve(res);
				// loader.dismiss();
			},(err)=>{
				// reject('잠시후 다시 시도하세요. <br> (만약 이 메세지가 계속 나올 시 관리자에게 문의바랍니다.)');
				reject(err);
				// loader.dismiss();
			});
		});
	}

	post_floor(url, body){
		return new Promise((resolve,reject)=>{
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(serverUrl, body, {headers:headers}).timeout(6000).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}

	lang_post(url, body){
		return new Promise((resolve,reject)=>{
			let serverAddr = localStorage.getItem("lang_http");
			let serverUrl = serverAddr+url;
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(serverUrl, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}

	sendCountry(url, body){
		return new Promise((resolve,reject)=>{
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(url, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
    }
    
    sendphoto(url, body){
		return new Promise((resolve,reject)=>{
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(url, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/services/HttpService.ts